import { ca } from '@cian/analytics';
/**
 * Клик по кнопке "Заполнить заявку", по которому происходит переход к опросу
 * https://conf.cian.tech/pages/viewpage.action?pageId=1469162427
 */
export const trackKpnSurveyButtonClick = () => {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'Fill_newbuilding_kpn_survey',
    label: '/sale/flat/object_type=2/from_developer=1/',
    name: 'oldevent',
  });
};
